import "./ProfileUserInformation.html";

import "./EditForm/ProfileUserInformationEditComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ProfileUserInformationComponentController from "./ProfileUserInformationComponentController";

export default class ProfileUserInformationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            profile: "<",
        };
        this.controller = ProfileUserInformationComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/Profile/UserInformation/ProfileUserInformation.html";
    }
}

module("mmAuth").component("mmProfileUserInformation", new ProfileUserInformationComponent());
